<template>
  <HeroSlider />
  <div class="max_width_1240_mauto home_main_sec mt-5 container">
    <div class="row">
      <div class="col">
        <h3 class="main_head mb-5">Better Sleep, Better Health</h3>
        <p class="text-center"><router-link class="MuiButton-contained green"
            to="/sleephealthscreen/terms-condition">Start My
            Sleep
            Assessment</router-link></p>
        <h5 class="small_heading">Sleep Health Assessment</h5>
        <p>Sleep is a non-negotiable biological requirement for human life; our need for sleep parallels our need for
          air, food, and water. <u>Given the universal need for sleep, it is not surprising that nearly 50% of adults
            suffer from one or more sleep disorders.</u> The problem is that most of us know when our sleep is
          disturbed, but how to explain the problem and to whom is more or less a mystery.</p>
        <p>There has long been a need for a self-assessment tool that is brief, comprehensive, and widely available. To
          accomplish this, a group of sleep experts developed a screening questionnaire called the <a
            href="/sleephealthscreen/Klingman Intro to SDS-CL-25 smr-2017-00010.pdf" target="_blank"
            rel="noopener noreferrer">SDS-CL-25</a>. This was further developed as a digital application
          by the Hypknowledge group and made available to the public at no cost with the support of sleep industry
          partners.</p>
      </div>
    </div>
  </div>
  <div class="max_width_1240_mauto container">
    <div class="row">
      <div class="col-md-6">
        <img src="@/assets/sleep-1-collage.jpg" alt="sleep" style="max-width: 100%;">
      </div>
      <div class="col-md-6">
        <p><u>Despite the fact that sleep disorders are so prevalent, up to 80% go undetected, undiagnosed, and
            untreated.</u> Patients, therefore, need to be empowered to identify their sleep disorders symptoms and to
          communicate these in an effective way. This can be accomplished by completing the sleep health screen
          available here or via using the QR code which will take you to our mobile Sleep Health Screen app. The
          screener allows individuals to self-screen for symptoms of 13 sleep disorders and only takes 3-5 minutes to
          complete. The assessment results in two PDF documents which you can share with your healthcare clinicians.</p>
        <div class="button_wrapper d-flex">
          <a class="MuiButton-contained" href="https://www.youtube.com/watch?v=U-e8QIczRt0" target="_blank">Watch
            Video</a>
          <router-link class="MuiButton-contained" to="/sleephealthscreen/description-initiative">Description of
            the Initiative</router-link>
        </div>
        <div class="qrcode_wrapper d-flex">
          <img src="@/assets/sleep_health_qr_code.png" alt="Qrcode">
          <router-link class="MuiButton-contained green" to="/sleephealthscreen/terms-condition">Start My Sleep
            Assessment</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroSlider from './HeroSlider.vue';

export default {
  name: 'HomePage',
  components: {
    HeroSlider
  },
};
</script>

<style>
.button_wrapper {
  justify-content: center;
  gap: 30px;
  flex-direction: column;
  align-items: center;
}

.MuiButton-contained {
  text-align: center;
  border: none;
  width: max-content;
  padding: 7px 30px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  background-color: rgb(25 118 210);
  text-transform: none;
  color: #ffffff !important;
  text-decoration: none;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.MuiButton-contained.green {
  background-color: green;
}

.MuiButton-contained.green:hover {
  background-color: green;
}

.MuiButton-contained:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: #1565c0;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.qrcode_wrapper {
  flex-direction: column;
  text-align: center;
  margin-top: 30px;
  align-items: center;
}

.qrcode_wrapper img {
  max-width: 125px;
  margin: auto;
  margin-bottom: 30px;
}
</style>
